import type { FaireProductEntity } from "../../entity_types/product";

export const p_rfrg7a7q4g: FaireProductEntity = {
  token: "p_rfrg7a7q4g",
  type: "product",
  name: "Dainty Multi-Faceted Turquoise beads + solid Copper Bracelet",
  brandToken: "b_r3cuwn57s4",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/eec26ee74b1d3561b77d31371e41f50b42f99e1775ade540a6ac7143447d5acb.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f998c9faee3c349fd4e015ca6fa5bd0184e243a798a9c7fb819b0790091d34de.jpeg",
    "https://cdn.faire.com/fastly/29daa7b470dc7095464476933610ad2fb6f0becf04298ef5a15063c2e682e981.png",
    "https://cdn.faire.com/fastly/3c996681916a4c5783e8e06eb02b8943fde826a95500e43aa06cce873f55bc18.jpeg",
  ],
  priceDollars: 19.4,
  description:
    '\nFits most wrist. Size 6.5 - 7"\n\nDainty and Minimal Stretchy bracelets with multi-faceted 4mm Turquoise + 3mm Solid copper beads Every bracelet comes with a tag that lists the properties of the gemstones and copper and is packed in a cotton pouch. Purported benefits of wearing a copper bracelet include the following: Relieves pain and inflammation caused by arthritis. Sterilizes wounds (due to its antibacterial properties) Improves the immune system. Works as an antioxidant. Prevents cardiovascular disease.\n',
  tags: [],
  msrpDollars: 38.8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:25.220Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
